// src/components/StatsBar.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';

import './StatsBar.css';

const LOCALES = {
  ru: 'ru-RU',
  en: 'en-GB',
  ka: 'ka-GE',
  hy: 'hy-AM',
  az: 'az-AZ',
  it: 'it-IT',
  fr: 'fr-FR'
};

export default function StatsBar({
  userAssets,
  level = 0,
  levelPoints = 0,
  nextLevelXP = 0,
  showGiftIcon,
  onGiftClick,
  onTicketsClick,
  onSkinsClick,
  onLevelClick
}) {
  const { t, i18n } = useTranslation();

  const ticketsCount = Array.isArray(userAssets?.tickets)
    ? userAssets.tickets.reduce(
        (total, ticket) =>
          total + Number(ticket?.quantity || 0),
        0
      )
    : 0;

  const skinsCount = Array.isArray(userAssets?.skins)
    ? userAssets.skins.reduce(
        (total, skin) =>
          total + Number(skin?.quantity || 0),
        0
      )
    : 0;

  const progress = Math.min(
    100,
    Math.round(
      (
        Number(levelPoints || 0) /
        Math.max(1, Number(nextLevelXP || 0))
      ) * 100
    )
  );

  const languageCode = String(
    i18n.resolvedLanguage ||
    i18n.language ||
    'ru'
  )
    .split('-')[0]
    .toLowerCase();

  const locale =
    LOCALES[languageCode] || LOCALES.ru;

  const formatNumber = (value) =>
    Number(value || 0).toLocaleString(locale);

  return (
    <div className="statsbar">
      <div className="statsbar__row">
        <button
          type="button"
          className="statsbar__item statsbar__link"
          onClick={onTicketsClick}
        >
          <span className="statsbar__label">
            {t('stats.tickets')}
          </span>

          <span
            key={`tickets-${ticketsCount}`}
            className="statsbar__value statsbar__value--gold"
            data-balance-target="tickets"
          >
            {formatNumber(ticketsCount)}
          </span>
        </button>

        <button
          type="button"
          className="statsbar__item statsbar__link"
          onClick={onSkinsClick}
        >
          <span className="statsbar__label">
            {t('stats.skins')}
          </span>

          <span
            key={`skins-${skinsCount}`}
            className="statsbar__value statsbar__value--gold"
            data-balance-target="skins"
          >
            {formatNumber(skinsCount)}
          </span>
        </button>

        <button
          type="button"
          className="statsbar__item statsbar__item--level statsbar__link"
          onClick={onLevelClick}
          title={t('stats.openLevel')}
        >
          <span className="statsbar__label">
            {t('stats.level')}
          </span>

          <span className="statsbar__value">
            {formatNumber(level)}
          </span>

          <div
            className="statsbar__xp"
            data-balance-target="xp"
          >
            <div
              className="statsbar__xp-fill"
              style={{ width: `${progress}%` }}
            />
          </div>
        </button>

        <div className="statsbar__item statsbar__item--gift">
          {showGiftIcon && (
            <button
              type="button"
              className="gift-btn"
              aria-label={t('stats.claimReward')}
              title={t('stats.claimReward')}
              onClick={() => onGiftClick?.()}
            >
              <img
                src="/img/CardPrize.png"
                alt={t('stats.gift')}
                className="gift"
              />
            </button>
          )}

          <span className="statsbar__xp-text">
            {formatNumber(levelPoints)}

            <span className="statsbar__slash">
              {' / '}
            </span>

            <span className="statsbar__target">
              {formatNumber(nextLevelXP)}{' '}
              {t('stats.xp')}
            </span>
          </span>
        </div>
      </div>
    </div>
  );
}